import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  H5,
  H6,
} from "@sellar-io/components";
import {
  DeliveryChargeFulfillmentType,
  FulfillmentTypeListResponseType,
} from "@sellar-io/api-v2/types";
import { generateContainerTypeDeliveryChargeRulesText } from "@sellar-io/common";
import { useState } from "react";
import { Icon } from "../../../../components";
import {
  TableLegacy,
  TableLegacyContainer,
  TableLegacyTHead,
  TableLegacyTR,
  TableLegacyTH,
  TableLegacyTD,
} from "../../../../components/table/TableLegacy";

import { ContainerTypeDeliveryChargeRuleCreateDialog } from "../dialogs/ContainerTypeDeliveryChargeRuleCreateDialog";
import { ContainerTypeDeliveryChargeRuleUpdateDialog } from "../dialogs/ContainerTypeDeliveryChargeRuleUpdateDialog";

type ContainerTypeDeliveryChargeRule =
  FulfillmentTypeListResponseType[number]["ContainerTypeDeliveryChargeRules"][number];

const TableRow = ({
  containerTypeDeliveryChargeRule,
  onEdit,
}: {
  containerTypeDeliveryChargeRule: ContainerTypeDeliveryChargeRule;
  onEdit: (deliveryChargeRules: ContainerTypeDeliveryChargeRule) => void;
}) => {
  return (
    <>
      <TableLegacyTR>
        <TableLegacyTD className={"w-11/12"}>
          {generateContainerTypeDeliveryChargeRulesText(
            containerTypeDeliveryChargeRule,
          )}
        </TableLegacyTD>

        <TableLegacyTD
          className={"cursor-pointer"}
          onClick={() => onEdit(containerTypeDeliveryChargeRule)}
        >
          <Icon icon={"PENCIL"} />
        </TableLegacyTD>
      </TableLegacyTR>
    </>
  );
};

export const ContainerTypeDeliveryChargeRulesCard = ({
  containerTypeDeliveryChargeRulesList,
  fulfillmentTypeId,
  method,
}: {
  containerTypeDeliveryChargeRulesList: Array<ContainerTypeDeliveryChargeRule>;
  fulfillmentTypeId?: number;
  method: DeliveryChargeFulfillmentType;
}) => {
  const [createDialogActive, setCreateDialogActive] = useState(false);
  const [selectedDeliveryChargeRules, setSelectedDeliveryChargeRules] =
    useState<ContainerTypeDeliveryChargeRule>();

  return (
    <>
      <Card className="bg-white">
        <CardHeader className={twMerge("bg-white", "flex flex-col p-4")}>
          <H5>Free delivery by container type</H5>
          <H6>
            Offer free delivery by container type when your customers spend over
            a certain amount on products sold in those containers. Calculated
            before VAT and discounts.
          </H6>
        </CardHeader>

        <CardContent className={"p-4"}>
          <TableLegacyContainer className={"overflow-auto"}>
            <TableLegacy>
              <TableLegacyTHead>
                <TableLegacyTH>Free delivery rule</TableLegacyTH>
                <TableLegacyTH />
              </TableLegacyTHead>

              {containerTypeDeliveryChargeRulesList.map((el) => (
                <TableRow
                  key={el.id}
                  containerTypeDeliveryChargeRule={el}
                  onEdit={(deliveryChargeRules) => {
                    setSelectedDeliveryChargeRules(deliveryChargeRules);
                  }}
                />
              ))}
            </TableLegacy>
          </TableLegacyContainer>

          <Button
            onClick={() => {
              setCreateDialogActive(true);
            }}
            className={"mt-2"}
            color={"tertiary"}
          >
            <Icon icon={"PLUS_CIRCLE"} />
            Add delivery rule
          </Button>
        </CardContent>
      </Card>
      <ContainerTypeDeliveryChargeRuleCreateDialog
        active={createDialogActive}
        onDismiss={() => setCreateDialogActive(false)}
        fulfillmentType={method}
        fulfillmentTypeId={fulfillmentTypeId}
      />

      {selectedDeliveryChargeRules && (
        <ContainerTypeDeliveryChargeRuleUpdateDialog
          active={!!selectedDeliveryChargeRules}
          onDismiss={() => setSelectedDeliveryChargeRules(undefined)}
          existingDeliveryChargeRule={{
            ...selectedDeliveryChargeRules,
            value: selectedDeliveryChargeRules.value,
          }}
        />
      )}
    </>
  );
};
